import { render, staticRenderFns } from "./CustomerDeleteDialog.vue?vue&type=template&id=9a8963a2"
import script from "./CustomerDeleteDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports